import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import Features from '@/components/Features'
import Pricing from '@/components/Pricing'
import SignUp from '@/components/SignUp'
import JoinBeta from '@/components/JoinBeta'
import Callback from '@/components/Callback'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/features',
      name: 'features',
      component: Features
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/join',
      name: 'join-beta',
      component: JoinBeta
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
      props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js